"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Joboffer = _interopRequireDefault(require("../Joboffer"));

var _ProfileNotActive = _interopRequireDefault(require("./ProfileNotActive"));

var _FooterNavigation = _interopRequireDefault(require("../FooterNavigation"));

var _Matches = require("../../provider/Matches");

var _Profile = require("../../provider/Profile");

var _Judgements = require("../../provider/Judgements");

var _Authentication = require("../../provider/Authentication");

var _Tracking = require("@jobmatchme/tracking/es/provider/Tracking");

var _usePrevious = _interopRequireDefault(require("@jobmatchme/library-utils/es/hooks/usePrevious"));

var _getkmfromcoord = _interopRequireDefault(require("../../utils/getkmfromcoord"));

var _Dislike = _interopRequireDefault(require("../Animation/Dislike"));

var _AppTabs = require("../AppTabs");

var _Like = _interopRequireDefault(require("../Animation/Like"));

var _package = require("../../../package.json");

var _CheckoutPage = _interopRequireDefault(require("../CheckoutPage"));

var _Swiper = _interopRequireDefault(require("../Swiper"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Matches = function Matches() {
  var _useContext = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext.user,
      isLoading = _useContext.isLoading;

  var matches = (0, _react.useContext)(_Matches.MatchesContext);
  var profile = (0, _react.useContext)(_Profile.ProfileContext);
  var judgements = (0, _react.useContext)(_Judgements.JudgementsContext);
  var animateTab = (0, _react.useContext)(_AppTabs.TabAnimationContext);

  var _useComponentTracking = (0, _Tracking.useComponentTracking)('Matches'),
      pcDataLayerPush = _useComponentTracking.pcDataLayerPush;

  var animationTimeoutRef = (0, _react.useRef)(null);
  var viewTimeoutRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    type: ''
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      animation = _useState2[0],
      setAnimation = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      currentMatchIndex = _useState4[0],
      setCurrentMatchIndex = _useState4[1];

  var hasMatches = matches.list.length > 0;
  var prevMatchIndex = (0, _usePrevious.default)(currentMatchIndex);
  (0, _react.useEffect)(function () {
    if (!isLoading && user && matches.status === 'done' && matches.list.length > 0) {
      if (viewTimeoutRef.current) {
        clearTimeout(viewTimeoutRef.current);
      }

      // Calculate distance for current Joboffer
      var trackDistance = function trackDistance(data) {
        return {
          distance: (0, _getkmfromcoord.default)(data.searchLocation ? data.searchLocation.latitude : 0, data.searchLocation ? data.searchLocation.longitude : 0, data.jobLocation ? data.jobLocation.latitude : 0, data.jobLocation ? data.jobLocation.longitude : 0).toFixed(0),
          jobId: data.jobId
        };
      };

      viewTimeoutRef.current = setTimeout(function () {
        // Send to GA
        pcDataLayerPush('view_match', profile);
        (0, _Tracking.trackEvent)({
          eventName: 'matchDetailView',
          pcUuid: user.username,
          payload: {
            position: currentMatchIndex + 1,
            totalJoboffers: matches.list.length,
            match: matches.list[currentMatchIndex],
            version: _package.version,
            jobofferDistances: trackDistance(matches.list[currentMatchIndex])
          }
        });
      }, 1000);
    } // Make sure to clear the timeout when the componentn unmounts


    return function () {
      if (viewTimeoutRef.current) clearTimeout(viewTimeoutRef.current);
    };
  }, [profile, currentMatchIndex, prevMatchIndex, matches.status, matches.list, isLoading, user, pcDataLayerPush]);
  (0, _react.useEffect)(function () {
    if (!isLoading && user && matches.status === 'done') {
      viewTimeoutRef.current = setTimeout(function () {
        // GTAG Event repeat call check
        localStorage.setItem('matchingWasLoaded', 'true');
      }, 1000);
    }

    return function () {
      if (viewTimeoutRef.current) clearTimeout(viewTimeoutRef.current);
    };
  }, [currentMatchIndex, matches.status, user, isLoading, matches.list, profile.discriminator]);

  var getAnimatedJobofferCard = function getAnimatedJobofferCard() {
    switch (animation.type) {
      case 'like':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Like.default, {
          show: true
        });

      case 'dislike':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dislike.default, {
          show: true
        });

      default:
        return '';
    }
  };

  var scrollTo = function scrollTo(elem) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var behavior = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'smooth';
    return new Promise(function (res) {
      return viewTimeoutRef.current = setTimeout(function () {
        if (document && typeof document.getElementById(elem) !== 'undefined') {
          var element = document.getElementById(elem); //Offset while Header hight

          var yOffset = offset;
          var y = element ? element.getBoundingClientRect().top + window.pageYOffset + yOffset : undefined;

          if (window && element) {
            window.scrollTo({
              top: y,
              behavior: behavior
            });
            res();
          }
        }

        return function () {
          if (viewTimeoutRef.current) clearTimeout(viewTimeoutRef.current);
        };
      }, 30);
    });
  };

  var determineMatchStatus = function determineMatchStatus(jobId, judgements) {
    if (((judgements || {}).userLikes || []).indexOf(jobId) !== -1) {
      return 'like';
    }

    if (((judgements || {}).userDislikes || []).indexOf(jobId) !== -1) {
      return 'dislike';
    }

    return 'notProcessed';
  };

  var currentMatch = matches.list[currentMatchIndex] || {};
  var currentMatchStatus = determineMatchStatus(currentMatch.jobId, judgements);

  var distance = function distance(data) {
    return (0, _getkmfromcoord.default)(data.searchLocation ? data.searchLocation.latitude : 0, data.searchLocation ? data.searchLocation.longitude : 0, data.jobLocation ? data.jobLocation.latitude : 0, data.jobLocation ? data.jobLocation.longitude : 0).toFixed(0);
  };

  var steps = (0, _react.useMemo)(function () {
    return matches.list.map(function (match, index) {
      return /*#__PURE__*/(0, _react.createElement)(_Joboffer.default, (0, _extends2.default)({}, match, {
        key: "match".concat(index),
        distance: distance(match),
        animation: animation.jobId === match.jobId && animation.type,
        status: determineMatchStatus(match.jobId, judgements),
        discriminator: match.discriminator,
        count: matches.list.length,
        scrollTo: scrollTo,
        index: index
      }));
    });
  }, [animation.jobId, animation.type, matches.list, judgements]);
  var matchesNumber = matches.list.length - 1;
  var handleNext = (0, _react.useCallback)(function () {
    if (animationTimeoutRef.current) clearTimeout(animationTimeoutRef.current); // Clear timeout on navigation

    scrollTo('topPosition', 0);
    setCurrentMatchIndex(function (index) {
      if (index < matchesNumber) {
        return index + 1;
      }

      return 0;
    });
    animateTab('');
    setAnimation({
      type: ''
    });
  }, [animateTab, matchesNumber]);
  var handlePrev = (0, _react.useCallback)(function () {
    if (currentMatchIndex > 0) {
      if (animationTimeoutRef.current) clearTimeout(animationTimeoutRef.current); // Clear timeout on navigation

      setCurrentMatchIndex(currentMatchIndex - 1);
      animateTab('');
      setAnimation({
        type: ''
      });
      scrollTo('topPosition');
    }
  }, [animateTab, currentMatchIndex]);
  var animateJudgement = (0, _react.useCallback)(function (judgement, id) {
    setAnimation({
      jobId: id,
      type: judgement
    });

    if (judgement === 'like') {
      animateTab('jobs');
    } else {
      animateTab('');
    }

    animationTimeoutRef.current = setTimeout(function () {
      handleNext();
      setAnimation({
        type: ''
      });
    }, 5000);
  }, [animateTab, handleNext]);
  return profile.active ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_styleModule.default.animation, " ").concat(animation.type === 'like' || animation.type === 'dislike' ? _styleModule.default.displayBlock : _styleModule.default.displayNone),
      children: getAnimatedJobofferCard()
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.box,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        id: "topPosition",
        className: _styleModule.default.topPosition
      }), matches.status !== 'done' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Joboffer.default, {
        animation: "loading"
      }) : matches.status === 'done' && (hasMatches ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Swiper.default, {
        index: currentMatchIndex,
        setIndex: setCurrentMatchIndex,
        children: steps
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutPage.default, {}))]
    }), hasMatches && matches.status === 'done' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterNavigation.default, {
      scrollTo: scrollTo,
      handleNext: handleNext,
      handlePrev: handlePrev,
      index: currentMatchIndex,
      loaded: judgements.loaded,
      onJudgement: animateJudgement,
      currentMatchId: currentMatch.jobId,
      matchMeta: {
        bookingId: currentMatch.bookingId
      },
      stepsCount: steps && steps.length ? steps.length : 1,
      currentMatchRevision: currentMatch.revision,
      currentProfileRevision: profile.revision,
      currentDiscriminator: profile.discriminator,
      navigationDisabled: matches.status !== 'done',
      currentMatch: currentMatch,
      judgementsDisabled: !judgements.loaded || matches.status !== 'done' || currentMatchStatus !== 'notProcessed' || profile.active !== undefined && !profile.active
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileNotActive.default, {
    user: user
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(Matches);

exports.default = _default;